// --------------------------------------------------------------
// Created On: 2021-08-26
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useEffect } from "react";
import { SHOW_TOAST_MILLISECONDS } from "../../constants/miscellaneous";
import styles from "./Toast.module.scss";

// A toast that displays a message.
export default function Toast(props: Props): Component {
  // Hide the toast automatically after it has been shown for some time.
  useEffect(() => {
    if (props.show) {
      const newTimerId = setTimeout(() => props.onClose(), SHOW_TOAST_MILLISECONDS);
      return () => {
        clearTimeout(newTimerId);
      };
    }
  }, [props.show]);

  return props.show ? (
    <div
      className={
        `${styles.body}` +
        ` ${props.type === "error" ? styles.error : ""}` +
        ` ${props.type === "success" ? styles.success : ""}`
      }
      onClick={() => props.onClose()}
      role="alert"
    >
      <div className={styles.header}>
        <strong className="me-auto">{props.title}</strong>
      </div>

      <div className={styles.content}>{props.message}</div>
    </div>
  ) : null;
}

interface Props {
  title: string;
  message: string;
  show: boolean;
  type?: "success" | "error";
  onClose: () => void;
}
